import api from '@/lib/api'
import { ENDPOINTS } from '@/constants/endpoints'

export interface VerifyFinessRequest {
  finess_number: string
}

export interface Facility {
  name: string
  [key: string]: unknown
}

export interface VerifyFinessResponse {
  name: string
  [key: string]: unknown
}

export const facilitiesService = {
  verifyFiness: async (payload: VerifyFinessRequest): Promise<{ data: VerifyFinessResponse }> => {
    const response = await api.post<VerifyFinessResponse>(
      ENDPOINTS.FACILITIES.VERIFY_FINESS,
      payload
    )
    return { data: response.data }
  },
}
